import {
  Account,
  AccountGroupMembership,
} from '@libs/src/models/account.model';
import { OPPORTUNITY_STATUS } from '@main-client/src/app/opportunity/opportunity-status.enum';
import { OPPORTUNITY_TYPES } from '@main-client/src/app/opportunity/opportunity-types.enum';
import { Opportunity } from '@main-client/src/app/opportunity/opportunity.model';

import get from 'lodash-es/get';

export enum NEWS_ROUTE_PATHS {
  'article' = 'article',
  'articles' = 'articles',
  'content' = 'content',
  'create' = 'create',
  'drafts' = 'drafts',
  'edit' = 'edit',
  'hosting' = 'hosting',
  'news' = 'news',
  'past' = 'past',
  'slug' = 'slug',
  'upcoming' = 'upcoming',
}

export interface GetOpportunitiesParams {
  eventEndDateMin?: Date;
  eventEndDateMax?: Date;
  groupIds?: string[];
  keyword?: string;
  limit?: number;
  opportunityType?: string;
  order?: number;
  'orFilter.featuredAccountIds'?: string[];
  'orFilter.groupIds'?: string[];
  skip?: number;
  sort?: string;
  status?: string;
}

export interface GetOpportunitiesResponse {
  items: Opportunity[];
  total_count: number;
}

export const DEFAULT_STATE = {
  items: [] as any[],
  totalCount: 0,
};
export const CAN_DEACTIVATE_PROMPT_DIALOG_CONFIG = {
  title: 'You have unsaved changes',
  content: `If you leave now your changes won't be saved.`,
  cancel: 'Stay',
  confirm: 'Leave',
};

const statusParamForFilter = {
  [NEWS_ROUTE_PATHS.upcoming]: OPPORTUNITY_STATUS.active,
  [NEWS_ROUTE_PATHS.drafts]: OPPORTUNITY_STATUS.draft,
  [NEWS_ROUTE_PATHS.past]: OPPORTUNITY_STATUS.active,
};

const timeParamForFilter = {
  [NEWS_ROUTE_PATHS.upcoming]: 'eventEndDateMin',
  [NEWS_ROUTE_PATHS.past]: 'eventEndDateMax',
};

export const DEFAULT_GET_PARAMS = {
  limit: '10',
  order: '-1',
  skip: '0',
  sort: 'event_start_date',
};

export function getDeleteNewsItemDialogText(opportunity: Opportunity) {
  return {
    title: 'Deleting Article',
    cancel: 'Cancel',
    confirm: 'Delete',
    content: `Are you sure you want to delete "${opportunity.title}"? You cannot undo this operation.`,
  };
}

export function buildGetParamsForOpportunities(
  groupId: string,
  filter: string,
  user: Account,
) {
  const now = new Date();
  now.setMinutes(0);
  const timeFilter = (timeParamForFilter as any)[filter]
    ? { [(timeParamForFilter as any)[filter]]: now.toISOString() }
    : {};
  return {
    order: -1,
    opportunityType: OPPORTUNITY_TYPES.regular,
    status: (statusParamForFilter as any)[filter],
    ...timeFilter,
    ...generateGetParamsPermittedForUser(user, groupId),
  };
}

function generateGetParamsPermittedForUser(user: Account, groupId: string) {
  if (user.isAdmin) {
    return groupId ? { groupIds: [groupId] } : {};
  }
  const userId = get(user, '_id');
  const userGroupIds = user.groups.map(
    (groupMembership: AccountGroupMembership) =>
      get(groupMembership, 'document._id'),
  );
  if (!groupId) {
    return {
      'orFilter.featuredAccountIds': [userId],
      'orFilter.groupIds': userGroupIds,
    };
  }
  return { groupIds: [groupId] };
}
